module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-form-fieldset', {
    attrs: {
      "label": "from a list of"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("PLU")]), _vm._v(" "), _c('th', [_vm._v("Product")]), _vm._v(" "), (_vm.enableSubsidy) ? _c('th', [_vm._v("Regular price")]) : _vm._e(), _vm._v(" "), (_vm.enableSubsidy) ? _c('th', [_vm._v("Sales price")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.value), function(product) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(product.plu))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(product.name))]), _vm._v(" "), (_vm.enableSubsidy) ? _c('td', [_vm._v(_vm._s(_vm.getBasePrice(product)))]) : _vm._e(), _vm._v(" "), (_vm.enableSubsidy) ? _c('td', [_vm._v(_vm._s(_vm._f("rounded")(_vm.getDiscountedPrice(product))))]) : _vm._e()])
  }))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-02891d2a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ViewEvent/ViewPromotion/ProductList.vue
// module id = 1668
// module chunks = 1